import utils from '../utils/util';
import queryParams from './pageQuery.service';
import { reportCoin } from './ics/cheCoinMall.report';
import util from '@/utils/util';
const isICSApp = util.isICSApp();
let basicModel = {};
let extendModel = {};
let deviceId = '';
if (utils.browser.isApp || utils.browser.isPriceApp) {
  deviceId = utils.getCookie('app_deviceid', '');
}
const container = {
  /**
   * 构建参数
   * @param {*} basic
   * @param {*} extend
   * @return  {Object}  {basic,extend}
   */
  buildBasicAndExtend(basic, extend) {
    const targetBasicModel = Object.assign({}, basicModel, basic);
    const targetExtendModel = Object.assign({}, extendModel, extend);
    return {
      basic: targetBasicModel,
      extend: targetExtendModel,
    };
  },
  buildBasic(action) {
    const { sceneId } = getPanoInfo();
    let dealerId = (this.baseInfo && this.baseInfo.dealerId) || 0;

    return {
      biz: 'dlr',
      type: 'common',
      scene: sceneId,
      action: action,
      room: dealerId,
      dealer: dealerId,
      from: '',
      id: '',
      time: new Date().getTime(),
      list: '',
      area: '',
      ctime: new Date().getTime(),
      abtest: window.abTestCtx?.envVars?.rtcUI || '',
    };
  },
  /**
   * 跟踪日志
   */
  pvTrackLogger({ action, basic, extend }) {
    let dealerId = 0;
    let dealerInfoId = 0;
    let source = 'dealerm';
    if (this.baseInfo) {
      dealerId = this.baseInfo.dealerId;
      dealerInfoId = this.baseInfo.dealerInfoId;
      source = this.baseInfo.source;
    }
    const { sceneId } = getPanoInfo();
    const _pvareaid = utils.getUrlParam('pvareaid');
    var activityid = '';
    const abTest = window.abTestCtx?.envVars?.rtcUI || '';
    extend = Object.assign(
      {
        sceneId,
        vrmode: 0,
        busid: '1508388243600',
        appflag: source,
        showid: '',
        packid: 0,
        activityid: activityid,
        deviceid: deviceId,
        actid: 0,
        userid: 0,
        pvareaid: _pvareaid,
        dealer_id: dealerId,
        dealerId: dealerId,
        dealerInfoId: dealerInfoId,
        abtest: abTest,
        uiStyleType: abTest,
      },
      extend || {},
    );
    basic = Object.assign(this.buildBasic(action), basic || {});
    const trackCustomEvent = window.trackCustomEvent;
    if (!trackCustomEvent) {
      return;
    }
    if (basic && basic.type === 'show') {
      setTimeout(function () {
        trackCustomEvent('dlr_vr_car_common_event', basic, extend);
      }, 0);
    } else if (basic && basic.type === 'show2') {
      basic.type = basic.showType;
      setTimeout(function () {
        trackCustomEvent('auto_common_show', basic, extend);
      }, 0);
    } else if (basic && basic.type === 'click') {
      trackCustomEvent('dlr_vr_car_common_event', basic, extend);
      // 前端上报操作日志接口=》用于i车币获取来源;
      container.pvTrackLoggerReport(basic, extend);
    } else if (basic && basic.type === 'heart') {
      trackCustomEvent('dlr_vr_car_jump', basic, extend);
    } else {
      trackCustomEvent('dlr_vr_car_common_event', basic, extend);
    }
  },
  pvTrackLoggerReport(basic, extend) {
    if (isICSApp && extend.channelId) {
      reportCoin({
        action: basic.action,
        channelId: extend.channelId,
      });
    }
  },
  /**
   * 重写指令跟踪
   * @param {返回对象} object
   * @param {当前vue实例} _vue
   */
  directiveTrack(object) {
    if (!object.action) {
      console.warn('can not find action in this tranck');
      return;
    }
    container.pvTrackLogger({
      action: object.action,
      basic: object.basic,
      extend: object.extend,
    });
  },
  /**
   * 启动埋点跟踪
   * @param {} vue
   * @param {*} context
   */
  start(baseInfo) {
    this.baseInfo = baseInfo;
    initPvTrack(baseInfo);
    setInterval(() => heartRequest(baseInfo), 5000);
  },
  /*
   * 点击埋点全部注册,在下元素上添加 data-stat-click 特性
   */
  startClickTrack() {
    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        while (target.parentNode !== null) {
          var attr = target.getAttribute('data-stat-click');
          if (attr) {
            try {
              var obj = JSON.parse(attr);
              if (obj && obj.action) {
                obj.basic = Object.assign(obj.basic || {}, { type: 'click' });
                console.log(
                  '触发点击事件：',
                  JSON.stringify({ action: obj.action, extend: obj.extend }),
                );
                container.pvTrackLogger({
                  action: obj.action,
                  basic: obj.basic,
                  extend: obj.extend,
                });
                break;
              }
            } catch (err) {}
          }
          target = target.parentNode;
        }
      },
      true,
    );
  },
  setParams(basic, extend) {
    if (basic) {
      basicModel = Object.assign({}, basicModel, basic);
    }
    if (extend) {
      extendModel = Object.assign({}, extendModel, extend);
    }
  },
};

function initPvTrack(baseData) {
  // document.domain = 'autohome.com.cn';
  var pvTrack = window.pvTrack || {};
  pvTrack.dealer = baseData.dealerId;
  pvTrack.pageVars = {};
  pvTrack.pageVars = Object.assign(pvTrack.pageVars, {
    cityId: queryParams.cityId || baseData.cityId || 0,
  }); // 页面自定义变量，键名自定义

  var _subjectTypeId = queryParams.subjectTypeId;
  if (_subjectTypeId) {
    pvTrack.pageVars = Object.assign(pvTrack.pageVars, {
      subjectTypeId: _subjectTypeId,
    });
  }
}
let panoInstance = null;
function getPanoInfo() {
  let sceneId = 0;
  if (!panoInstance) {
    panoInstance = document.getElementById('krpanoSWFObject');
  }
  if (panoInstance && panoInstance.get) {
    sceneId = panoInstance.get('scene[get(xml.scene)].id');
  }
  return { sceneId };
}

//心跳日志
function heartRequest(baseInfo) {
  const { sceneId } = getPanoInfo();
  container.pvTrackLogger({
    action: 'dealer_vr_heart',
    basic: {
      type: 'heart',
      scene: sceneId,
    },
    extend: {
      vrmode: 0,
      busid: '1508388243600',
      appflag: baseInfo.source || 'dealerm',
      deviceid: deviceId,
      actid: '',
      userid: '',
    },
  });
}

export default container;
